define(
	'eComm.InsertsExtension.InsertsExtension'
,   [
		'eComm.InsertsExtension.InsertsExtension.View',
		'SC.Configuration',
		'Profile.Model',
		'Cart.Item.Summary.View',
		'Cart.Item.Actions.View',
		'Transaction.Line.Views.Option.View',
		'ProductDetails.ImageGallery.View',

		'Backbone',
		'Backbone.CompositeView',
		'underscore',
		'Utils',
		'SuiteDynamics.InsertsExtension.ProductViews.Price.View.Extended'
	]
,   function (
		InsertsExtensionView,
		Configuration,
		ProfileModel,
		CartItemSummaryView,
		CartItemActionsView,
		TransactionLineViewsOptionView,
		ProductDetailsImageGalleryView,
		Backbone,
		BackboneCompositeView,
		_,
		Utils
	)
{
	'use strict';

	function automaticLogout(){
		var self = this;
		var userProfileComponent = this.container.getComponent("UserProfile");
		userProfileComponent.getUserProfile().then(function(profile) {
			if(profile.isloggedin && profile.isrecognized){
				//Check backend if the session is timeout
				var profileModel = ProfileModel.getInstance();
				profileModel.urlRoot =  Utils.getAbsoluteUrl(profileModel.urlRoot);
				profileModel.fetch().done(function (){
					if(profileModel.get('isLoggedIn') === 'F'){
						window.location = SC.ENVIRONMENT.siteSettings.touchpoints.home + SC.ENVIRONMENT.siteSettings.touchpoints.logout;
					}
				});
			}
		});
	}

	return  {
		mountToApp: function mountToApp (container){
			var layout = container.getComponent('Layout');
			var pdp = container.getComponent('PDP');
			var insertConfig = Configuration.get('insertsExtension.insertsConfiguration', []);
			var userProfileComponent = container.getComponent("UserProfile");
			var cart = container.getComponent("Cart");
			this.container = container;

			//Logout if isNotLoggedIn
			setInterval(automaticLogout.bind(this), 22 * 60 * 1000);

			if(layout){
				layout.removeChildView('Quick.Order');
				layout.on('afterShowContent', function (){
					jQuery('.header-menu-social-list a').attr('target', '_blank');
					// userProfileComponent.getUserProfile().then(function(profile) {
					// 	var isB2B = profile.isloggedin ? _.findWhere(profile.customfields, { id: "custentity_ano_is_b2b" }).value : false;
					// 	if(isB2B) {
					// 		jQuery('.header-top-content').empty();
					// 	}
					// });
				});
			}
			if(pdp){
				pdp.on('beforeShowContent', function (){
					var insertsItemClasses = _.uniq(_.pluck(insertConfig, 'shoetype'));
					var itemClass = pdp.getItemInfo().item.class;
					// pdp.removeToViewContextDefinition('ProductDetails.Quantity.View', 'showQuantity');
					// if(_.contains(insertsItemClasses, itemClass)){
					// 	pdp.addToViewContextDefinition('ProductDetails.Quantity.View', 'showQuantity', 'boolean', function(context) {
					// 		return false;
					// 	});
					// } else {
					// 	pdp.addToViewContextDefinition('ProductDetails.Quantity.View', 'showQuantity', 'boolean', function(context) {
					// 		return true;
					// 	});
					// }
				});

				pdp.on('afterShowContent', function (){
					var itemClass = pdp.getItemInfo().item.class;
					if(itemClass === 'Accessories'){
						pdp.setOption('custcol10', 'X');
						jQuery('div[data-cart-option-id="custcol10"]').remove();
					}
					if(jQuery('button.cart-add-to-cart-button-button').text().trim() === 'Update'){
						jQuery('#in-modal-custcol_ano_inserts_internalid-container').remove();
					}
				});
			}
				_.defer(function(){
					userProfileComponent.getUserProfile().then(function(profile) {
						
						var isB2B = profile.isloggedin ? _.findWhere(profile.customfields, { id: "custentity_ano_is_b2b" }).value : false;
						
						layout.addChildView('Quantity', function (){
							return new InsertsExtensionView({container: container, pdp: pdp, isB2B: isB2B});
						});
	
						_.extend(CartItemSummaryView.prototype, {
							initialize: _.wrap(CartItemSummaryView.prototype.initialize, function wrapInitialize(fn, options){
								var view = this;
								fn.apply(this, _.toArray(arguments).slice(1));
								this.on('afterViewRender', function (){
									if(!isB2B) {
										var hasAShoe = view.model.getOption('custcol_has_a_shoe');
										if(hasAShoe){
											jQuery('input[type="number"]', view.$el).prop('disabled', true);
										}
																
									}
								});
							})
						});
						
						_.extend(CartItemActionsView.prototype, {
							initialize: _.wrap(CartItemActionsView.prototype.initialize, function wrapInitialize(fn, options){
								var view = this;
								fn.apply(this, _.toArray(arguments).slice(1));
								this.on('afterViewRender', function (){
									if(!isB2B) {
										var hasAShoe = view.model.getOption('custcol_has_a_shoe');
										if(hasAShoe){
											jQuery('.cart-item-actions-links', view.$el).css("visibility", "hidden");	
										}				
									}
								});
							})
						});
						
						_.extend(TransactionLineViewsOptionView.prototype, {
							initialize: _.wrap(TransactionLineViewsOptionView.prototype.initialize, function wrapInitialize(fn, options){
								var view = this;
								fn.apply(this, _.toArray(arguments).slice(1));
								this.on('afterViewRender', function (){
									var optionId = view.model.get('cartOptionId');
									if(optionId === 'custcol_sd_inserts_parent_id' || optionId === 'custcol13' || optionId === 'custcol_sd_inserts_customer_segment' || optionId === 'custcol_has_a_shoe' || optionId === 'custcol_shoe_name'
										|| optionId === 'custcol_ano_inserts_free' || optionId === 'custcol_ano_inserts_quantity' || optionId === 'custcol_ano_inserts_internalid'
										|| optionId === 'custcol_ano_patient_name_seq'){
										jQuery('div.transaction-line-views-selected-option', view.$el).hide();		
									}				
								});
							})
						});
	
					
						if(cart){
						cart.cancelableOn('afterRemoveLine', function (line){
							//B2B don't need to update inserts combo
							if(isB2B){
								return;
							}
							cart.cancelableDisable('afterRemoveLine');
	
							cart.getLines().done(function (lines){
								var insertLines = _.filter(lines, function (line){
									var linePatientNameOption = _.findWhere(line.options, {cartOptionId: "custcol10"});
									var lineShoeNameOption =  _.findWhere(line.options, {cartOptionId: "custcol_shoe_name"});
									var hasAShoeOption =  _.findWhere(line.options, {cartOptionId: "custcol_has_a_shoe"});
									if(linePatientNameOption && lineShoeNameOption && hasAShoeOption
										&& hasAShoeOption.value.internalid == 'T'){
										return true;
									} else {
										return false;
									}		
								});
	
								var insertLine;
								for(var i= 0; i < insertLines.length; i++){
									var insertPatientNameOption = _.findWhere(insertLines[i].options, {cartOptionId: "custcol10"});
									var insertShoeNameOption =  _.findWhere(insertLines[i].options, {cartOptionId: "custcol_shoe_name"});
									var patientName = insertPatientNameOption.value.internalid;
									var shoeInternalid =  insertShoeNameOption.value.internalid;
	
									var shoe = _.find(lines, function (line){
										var itemid = line.item.internalid;
										var options = line.options;
										var itemPatientNameOption = _.findWhere(line.options, {cartOptionId: "custcol10"});
										if(itemid == shoeInternalid && patientName == itemPatientNameOption.value.internalid){
											return true;
										} 
										return false;
									});
								
									if(!shoe){
										insertLine = insertLines[i];
										break;
									}
								}
	
								if(insertLine){
									cart.removeLine({line_id: insertLine.internalid}).done(function (){
										cart.cancelableEnable('afterRemoveLine');
									});
								} else {
									cart.cancelableEnable('afterRemoveLine');
								}
							});
						});
					}
					});

				});
				
				
			
		}

	};
});
